<template>
  <n-button v-rw ghost type="error" custom-icon="fas fa-sync-alt" text="schedule" @on-click="$emit('on-click')" />
</template>

<script>
export default {
  name: 'NbSchedule',
};
</script>
